import './SuggestionDetails.css';
export var suggestionDetails = '_r6yujm0-2-0-1';
export var suggestionDetailsText = '_r6yujm1-2-0-1';